var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportVolleyball24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sport_volleyball24x24",
    transform: "translate(1512.978 281.1)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45829",
    d: "M-1496.3-267.852a8.116,8.116,0,0,0,1.068-3.114c-.267-.178-.445-.356-.712-.534A12.4,12.4,0,0,1-1496.3-267.852Z",
    transform: "translate(-1.745 -1.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45830",
    d: "M-1499.675-272.7c.089,1.513.089,5.784-3.025,8.542a8,8,0,0,0,4.093-1.958,13.644,13.644,0,0,0,1.068-5.962A5.44,5.44,0,0,0-1499.675-272.7Z",
    transform: "translate(-1.04 -1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45831",
    d: "M-1501.078-272.7a6.8,6.8,0,0,0-2.971.89,7.028,7.028,0,0,1-1.35,3.826h0l-.09.089a7.453,7.453,0,0,1-2.611,2.136h-.09c-.27.089-.54.267-.81.356a8.749,8.749,0,0,0,4.141,1.335C-1500.808-266.471-1500.988-271.365-1501.078-272.7Z",
    transform: "translate(-.438 -1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45832",
    d: "M-1506.6-275.129a5.464,5.464,0,0,0,2.224,2.047,7.729,7.729,0,0,1,3.648-.979h.178a7.281,7.281,0,0,1,4.182,1.513,7.652,7.652,0,0,0-.8-3.47C-1501.083-278.333-1505.443-275.841-1506.6-275.129Z",
    transform: "translate(-.61 -.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45833",
    d: "M-1507.077-276.218c1.246-.8,5.161-2.936,9.076-1.513a7.582,7.582,0,0,0-3.559-2.669,10.841,10.841,0,0,0-6.14,1.869A6.866,6.866,0,0,0-1507.077-276.218Z",
    transform: "translate(-.489 -.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45834",
    d: "M-1504.408-281.011a9.757,9.757,0,0,0-3.2.623c0,.267-.089.534-.089.712a9.877,9.877,0,0,1,3.47-1.424C-1504.23-281.011-1504.319-281.011-1504.408-281.011Z",
    transform: "translate(-.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45835",
    d: "M-1506.231-269.467a6.525,6.525,0,0,0,1.068-3.114,6.993,6.993,0,0,1-2.669-2.669h0l-.089-.089a6.66,6.66,0,0,1-.89-3.2V-279.7a8.031,8.031,0,0,0-2.491,2.4C-1511.658-272.671-1507.477-270.09-1506.231-269.467Z",
    transform: "translate(-.182 -.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45836",
    d: "M-1508.815-266.858a7.421,7.421,0,0,0,1.869-1.424c-1.335-.712-4.894-3.025-5.428-7.118a7.693,7.693,0,0,0-.356,4.894A10.321,10.321,0,0,0-1508.815-266.858Z",
    transform: "translate(0 -.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45837",
    d: "M-1510.054-265.376c.178,0,.267-.089.445-.178a11.836,11.836,0,0,1-1.691-1.246A9.523,9.523,0,0,0-1510.054-265.376Z",
    transform: "translate(-.185 -1.681)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportVolleyball24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_volleyball24x24.a03e67ce145c7b7fee3ee42736848337.svg";